/**
 * To use form modal dialog.
 * Used by other components
 */
import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Modal,
  ModalFooter,
  ModalBody,
  ModalHeader,
  ModalTitle,
  CloseButton
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import y from 'y4/Utils';
import RT from 'y4/RT';

const ModalDialog = ({
  title,
  children,
  data,
  buttons,
  modalShow,
  setModalShow
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>
          <ModalTitle id="contained-modal-title-vcenter">{title}</ModalTitle>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          {buttons ? (
            buttons.map((button, index) => {
              return (
                <Button
                  key={index}
                  variant={button.variant}
                  onClick={() => {
                    //First check if there is a check function
                    if (button.check) {
                      //If there is, check the return value
                      const rt_check = button.check(data);
                      if (rt_check) {
                        var rt = new RT(rt_check);
                        if (rt.isNotOk()) {
                          //When there is an error, show the error message
                          y.toastError(rt.message);
                          return;
                        }
                      }
                    }
                    setModalShow(false);
                    if (button.click) {
                      button.click(data);
                    }
                  }}
                >
                  {_.startsWith(button.text, '__')
                    ? t(button.text.slice(2))
                    : button.text}
                </Button>
              );
            })
          ) : (
            <Button onClick={() => setModalShow(false)}>{t('Close')}</Button>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

ModalDialog.propTypes = {
  title: PropTypes.string,
  children: PropTypes.object,
  data: PropTypes.object,
  buttons: PropTypes.array,
  modalShow: PropTypes.bool,
  setModalShow: PropTypes.func
};

export default ModalDialog;
